export const CHECKBOX_TYPES = {
  SIMPLE: 'simple',
  LABEL: 'label',
  BOX_LABEL: 'boxLabel',
  BOX_TWO_LINES: 'boxTwoLines',
}
